import { useEffect, useRef, useState, ReactNode, FC, JSX } from "react";

interface PeriodicCardProps {
    updateFunction: (cache: Record<any, any>) => { content?: ReactNode | JSX.Element; cache?: Record<any, any> };
    updateInterval?: number;
}

const PeriodicCard: FC<PeriodicCardProps> = ({ updateFunction, updateInterval = 500 }) => {
    const timer = useRef<NodeJS.Timeout | null>(null);
    const [content, setContent] = useState<ReactNode | JSX.Element | null>(null);
    const lastCache = useRef<Record<any, any>>({});

    useEffect(() => {
        const dafn = () => {
            const back = updateFunction(lastCache.current);

            let { content, cache = lastCache.current } = back;

            lastCache.current = cache;

            if (content) {
                setContent(content);
            }
        };

        dafn();

        if (timer.current) {
            clearInterval(timer.current);
        }
        timer.current = setInterval(dafn, updateInterval);

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
            timer.current = null;
        };
    }, [updateFunction, updateInterval]);

    return <>{content}</>;
};

export default PeriodicCard;
